import { LOGIN_REQUEST, LOGOUT_REQUEST, SUCCESS, FAILURE } from "./authTypes";

// Try to restore auth state from localStorage on page load
const getInitialState = () => {
  const token = localStorage.getItem("jwtToken");
  const storedAuth = localStorage.getItem("authState");
  
  if (token && storedAuth) {
    try {
      const parsed = JSON.parse(storedAuth);
      return {
        username: parsed.username || "",
        email: parsed.email || "",
        role: parsed.role || "",
        isLoggedIn: true,
      };
    } catch (e) {
      return {
        username: "",
        email: "",
        role: "",
        isLoggedIn: false,
      };
    }
  }
  
  return {
    username: "",
    email: "",
    role: "",
    isLoggedIn: false,
  };
};

const initialState = getInitialState();

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
    case LOGOUT_REQUEST:
      return {
        ...state,
      };
    case SUCCESS:
      const newState = {
        username: action.payload.username || "",
        email: action.payload.email || "",
        role: action.payload.role || "",
        isLoggedIn: action.payload.isLoggedIn,
      };
      // Persist auth state to localStorage
      if (action.payload.isLoggedIn) {
        localStorage.setItem("authState", JSON.stringify(newState));
      } else {
        localStorage.removeItem("authState");
      }
      return newState;
    case FAILURE:
      localStorage.removeItem("authState");
      return {
        username: "",
        email: "",
        role: "",
        isLoggedIn: false,
      };
    default:
      return state;
  }
};

export default reducer;
